import { FormInstance } from 'antd';
import React from 'react';

const SubmitButton = ({
  form,
  final,
  passwordSuccess,
  step,
}: {
  form: FormInstance;
  final?: boolean;
  passwordSuccess?: boolean;
  step?: number;
}) => {
  const [submittable, setSubmittable] = React.useState(false);

  const handleCheckValidate = () => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmittable(true);
      },
      (res) => {
        if (res?.errorFields) {
          Array(res?.errorFields)?.forEach((item) => {
            form.setFields(item);
          });
        }

        setSubmittable(false);
      },
    );
  };

  return (
    <button
      type={
        passwordSuccess && step === 4
          ? 'submit'
          : submittable
          ? 'submit'
          : 'button'
      }
      onClick={handleCheckValidate}
      // disabled={!submittable || (!passwordSuccess && step === 4)}
      className="add_user_button is-pulled-right is-flex is-justify-content-center is-align-items-center"
    >
      <span>{final ? 'SAVE' : 'NEXT'}</span>
      {final ? (
        <img alt="submit" src="/icons/save.svg" />
      ) : (
        <img src="/icons/back_button.svg" alt="next" />
      )}
    </button>
  );
};
export default SubmitButton;
